// extracted by mini-css-extract-plugin
export var bacgroundImage = "StepsSection-module--bacgroundImage--b5d97";
export var btnContainer = "StepsSection-module--btnContainer--4775b";
export var buttonClassName = "StepsSection-module--buttonClassName--187c2";
export var contentClassname = "StepsSection-module--contentClassname--4aace";
export var extraOpenClassname = "StepsSection-module--extraOpenClassname--c15c5";
export var footerContainer = "StepsSection-module--footerContainer--85b77";
export var footerTitle = "StepsSection-module--footerTitle--69077";
export var headingContentContainer = "StepsSection-module--headingContentContainer--80dfb";
export var linkColor = "StepsSection-module--linkColor--ad425";
export var sectionStyles = "StepsSection-module--sectionStyles--63d79";
export var singleStep = "StepsSection-module--singleStep--57ec0";
export var stepsContentContainer = "StepsSection-module--stepsContentContainer--48486";
export var stepsWithBorder = "StepsSection-module--stepsWithBorder--062d6";
export var stepsWraping = "StepsSection-module--stepsWraping--d17d5";
export var titleClassname = "StepsSection-module--titleClassname--7bdcc";